var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("g", {
  id: "Filter",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic-filter-list-24px",
  transform: "translate(3.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7,12 L11,12 L11,10 L7,10 L7,12 Z M0,0 L0,2 L18,2 L18,0 L0,0 Z M3,7 L15,7 L15,5 L3,5 L3,7 Z",
  id: "Shape"
}))))));
export { SvgFilter as ReactComponent };
export default __webpack_public_path__ + "static/media/filter.dfd870fc.svg";